import { render } from "./EmployeeLeaveAge.vue?vue&type=template&id=0deed1b9"
import script from "./EmployeeLeaveAge.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveAge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__